export default class TrackEmojiUsage {
  constructor(context) {
    this.context = context;
  }

  run({ name }) {
    this.context.analytics.track('Emoji Used', { name });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/composer/track_emoji_usage.js